import { render, staticRenderFns } from "./form-item-phone.vue?vue&type=template&id=101ee97e"
import script from "./form-item-phone.vue?vue&type=script&lang=js"
export * from "./form-item-phone.vue?vue&type=script&lang=js"
import style0 from "./form-item-phone.vue?vue&type=style&index=0&id=101ee97e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../A8/pc/node_modules/.pnpm/vue-loader@15.11.1_@vue+com_5bba9927a18eaff02a55b79fc72fdde2/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports